import { Component, PipeTransform, Pipe, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { SwUpdate } from '@angular/service-worker';
import { DataService } from './data.service';
import { Subscription } from 'rxjs';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { NotificationService } from './services/notification.service';
import { SessionExpiredService } from './services/session-expired.service';

export let browserRefresh = false;

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'notify';
  lng: string = "";
  lat: string = "";
  location: object;
  subscription: Subscription;
  update: boolean = false;
  notify: any;
  video: string = "https://hospital.securenow.in/";
  
  // popup flag
  showUpdatePopup: boolean = false;
  countdown: number = 5;
  private countdownInterval: any;
  private updateActivationStarted: boolean = false;
  private sessionExpiredSubscription: Subscription;

  // notification preference prompt flag
  showNotificationPrompt: boolean = false;

  constructor(
    private updates: SwUpdate,
    private data: DataService,
    private router: Router,
    private notificationService: NotificationService,
    private sessionExpiredService: SessionExpiredService
  ) {
    if (updates.isEnabled) {
      updates.versionUpdates.subscribe(event => {
        console.log('SW event:', event.type);
        if (event.type === 'VERSION_DETECTED') {
          this.showUpdatePopup = true;
        }
        if (event.type === 'VERSION_READY') {
          this.startCountdown();
        }
      });

      this.checkForAppUpdate();
    }

    // updates.available.subscribe(event => {
    //   updates.activateUpdate().then(() => document.location.reload());
    // });

    this.subscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        browserRefresh = !router.navigated;
      }
      if (event instanceof NavigationEnd) {
        this.checkNotificationPrompt();
        this.checkForAppUpdate();
      }
    });

    this.sessionExpiredSubscription = this.sessionExpiredService.sessionExpired$.subscribe(() => {
      this.startCountdown();
    });
  }

  private checkForAppUpdate(): void {
    if (!this.updates.isEnabled || this.updateActivationStarted) return;

    this.updates.checkForUpdate()
      .then(hasUpdate => {
        if (hasUpdate) {
          this.startCountdown();
        }
      })
      .catch(error => {
        console.error('Failed to check for app update:', error);
      });
  }

  /**
   * Show the custom "enable notifications?" prompt once per user, the first
   * time they're logged in, before ever touching the native browser permission
   * dialog. Skips silently if already answered (via this prompt or the
   * settings toggle) or if the browser permission was already decided outside
   * the app.
   */
  private checkNotificationPrompt(): void {
    if (this.showNotificationPrompt) return;
    if (typeof window === 'undefined' || !('Notification' in window)) return;

    const userId = localStorage.getItem('userID');
    if (!userId) return;

    if (localStorage.getItem('isNotificationEnabled') !== null) return;

    if (Notification.permission === 'granted') {
      localStorage.setItem('isNotificationEnabled', 'true');
      return;
    }

    if (Notification.permission === 'denied') {
      localStorage.setItem('isNotificationEnabled', 'false');
      return;
    }

    this.showNotificationPrompt = true;
  }

  async onNotificationChoice(enable: boolean): Promise<void> {
    this.showNotificationPrompt = false;
    localStorage.setItem('isNotificationEnabled', enable ? 'true' : 'false');

    if (!enable) return;

    const userId = localStorage.getItem('userID');
    if (!userId) return;

    try {
      const result = await this.notificationService.enableForUser(userId);
      if (!result.success) {
        console.error('Failed to enable notifications:', result.error);
      }
    } catch (error) {
      console.error('Error enabling notifications:', error);
    }
  }

  startCountdown() {
    if (this.updateActivationStarted) return;

    this.updateActivationStarted = true;
    this.showUpdatePopup = true;
    this.countdown = 5;
    this.countdownInterval = setInterval(() => {
      this.countdown--;
      if (this.countdown === 0) {
        clearInterval(this.countdownInterval);
        localStorage.clear();
        sessionStorage.clear();
        this.updates.activateUpdate()
          .catch(error => console.error('Failed to activate app update:', error))
          .then(() => document.location.reload());
      }
    }, 1000);
  }

  ngOnInit() {
    this.data.getLocation().subscribe(data => {
      console.log(data);
      this.lat = data.latitude;
      this.lng = data.longitude;
    });

    this.data.getNotifyWPA().subscribe(res => {
      this.notify = res;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.sessionExpiredSubscription.unsubscribe();
    if (this.countdownInterval) clearInterval(this.countdownInterval);
  }
}
